// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SwapUsersSelect_wrapper__1Iar3"};